import { render, staticRenderFns } from "./PricePanelAddForm.vue?vue&type=template&id=192e2a98"
import script from "./PricePanelAddForm.vue?vue&type=script&lang=js"
export * from "./PricePanelAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports